module.exports = __webpack_public_path__ + "img/状态映射.d0e71f0a.svg";